export default __webpack_public_path__ + "static/media/logoFooter.a7fef84f.png";